import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchingExternalLibrary} from "actions/media";

import _ from "lodash";
import cx from "classnames";
import { ExternalMedia, PreviewExternalMedia } from "../ExternalMedia";

import { Button, Nav, Tab, Dropdown, InputGroup, Form } from "react-bootstrap";
import InfiniteScroll from "components/InfiniteScroll";

import styles from "./externalMediaPalette.module.scss";

export const ExternalMediaPalette = ({active, handleMediaLibrary, onSelect, orientation, mediaLibraryType, editorSession, target, onClose,}) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    active: "image",
    selected: [],
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState({
    label: "Images",
    value: "image",
  });
  const [preview, setPreview] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const uploads = useSelector((state) => _.get(state, "media.uploads")) || [];
  const uploadError = useSelector((state) => _.get(state, "media.externalMedia.uploadError"));
  const mediaList = useSelector((state) => _.get(state, "media.externalMedia.items")) || [];
  const loading = useSelector((state) => _.get(state, "media.externalMedia.loading"));
  const loaded = useSelector((state) => _.get(state, "media.externalMedia.loaded", false));
  const loadMore = useSelector((state) => _.get(state, "media.externalMedia.loadMore"));
  const pagination = useSelector((state) => _.get(state, "media.externalMedia.pagination"));
  const hasMoreItems = loadMore && _.get(pagination, "currentPage") < 30;

  const filterTypeOption = [
    {
      label: "Images",
      value: "image",
    },
    {
      label: "Videos",
      value: "video",
    },
  ];

  const handleTabChange = (active) => {
    setState((state) => {
      return {
        ...state,
        active: active,
      };
    });
  };

  const openMediaLibrary = (e) => {
    e.stopPropagation();
    handleMediaLibrary();
  };

  const loadMoreMedia = () => {
    let totalPages = 30;
    let currentPage = pagination.currentPage;
    let nextPage = currentPage + 1;

    if (loading || nextPage > totalPages) {
      return;
    }
    const request = {
      mediaType: filterType.value,
      mediaLibraryType: mediaLibraryType,
      orientation: orientation,
      page: nextPage,
      query: searchQuery
    };

    dispatch(fetchingExternalLibrary(request));
  };

  const handleSearch = () => {
    var request = {
      mediaType: filterType.value,
      mediaLibraryType: mediaLibraryType,
      orientation: orientation,
      query: searchQuery,
      page: 0
    };
    dispatch(fetchingExternalLibrary(request));
  };

  useEffect(() => {
    if (!loaded && active === 'pexels') {
      const request = {
        mediaType: filterType.value,
        mediaLibraryType: mediaLibraryType,
        orientation: orientation,
        query: searchQuery,
        page: 0
      };

      dispatch(fetchingExternalLibrary(request));
    }
  }, [active]);

  useEffect(() => {
    if (uploads.length > 0 || uploadError) {
      handleMediaLibrary();
    }
  }, [uploads, uploadError]);

  const handlePreview = (item) => {
    setSelectedImage(item);
    setPreview(true);
  };

  const handleOnClose = () => {
    setPreview(false);
    onClose();
  };

  return (
    <>
      {preview && (
        <PreviewExternalMedia
          show={preview}
          onSelect={onSelect}
          setShow={setPreview}
          selectedMedia={selectedImage}
          onClose={handleOnClose}
          editorSession={editorSession}
          target={target}
        />
      )}

      <div className={styles.externalMediaPalette}>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="image"
          onSelect={handleTabChange}
        >
          <div className={cx(styles.palatteHeader, "handle")}>
            <div className={styles.tabsButtonTray}>
              <UploadContent openMediaLibrary={openMediaLibrary} />
            </div>

            <div className={styles.search}>
              <InputGroup className={styles.searchBox}>
                <Form.Control
                  className={styles.searchInput}
                  placeholder="Search in Pexels"
                  aria-label="Search in Pexels"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  aria-describedby="Pexel search"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
                <InputGroup.Text
                  className={styles.searchIcon}
                  id="basic-addon1"
                  onClick={handleSearch}
                >
                  <i className="cleverstory-search" />
                </InputGroup.Text>
              </InputGroup>
            </div>

            <div className={styles.filter}>
              <Dropdown className={styles.storboardTypeDropdown}>
                <Dropdown.Toggle id="dropdown-custom-components">
                  <i
                    className={cx(styles.filterIcon, "cleverstory-filter")}
                  ></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {filterTypeOption.map((option, index) => {
                    return (
                      <Dropdown.Item
                        active={option.value == filterType.value}
                        onClick={() => setFilterType(option)}
                        key={index}
                        eventKey={index}
                      >
                        {option.label}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className={styles.tabContentView}>
            {mediaList.length != 0 && (
              <InfiniteScroll
                lassName={styles.scrollable}
                loading={loading}
                hasMore={hasMoreItems}
                loadMore={() => {
                    loadMoreMedia();
                }}
                pageStart={0}
                threshold={250}
              >
                <div className={styles.grid}>
                  {mediaList.map((media, index) => {
                    return (
                      <ExternalMedia
                        key={index}
                        media={media}
                        onPreviewClick={() => handlePreview(media)}
                      />
                    );
                  })}
                </div>
              </InfiniteScroll>
            )}
          </div>

          {loading && mediaList.length == 0 && <p className={styles.loading}>Fetching...</p>}

          {!loading && mediaList.length == 0 && searchQuery != "" && (
            <>
              <div className={styles.errorMessageContent}>
                <p className={styles.errorMessageTitle}>
                  We couldn’t find anything for "{searchQuery}".
                  <br /> Try to refine your search.
                </p>
                <button onClick={()=>{setSearchQuery("")}} className={styles.errorMessageButton}>Clear Search</button>
              </div>
            </>
          )}
        </Tab.Container>
      </div>
    </>
  );
};

const UploadContent = ({ openMediaLibrary, storyboard, mediaTypes }) => {
  return (
    <Button onClick={openMediaLibrary} className={styles.uploadMediaBtn}>
      <i className={cx("cleverstory-grid-view", styles.uploadIcon)} />Media Library
    </Button>
  );
};